module.exports = __webpack_public_path__ + "static/logo-26eb55331008c6716b25b6c883c918dd.png";